import React, { FC, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import PaymentSuccess from '@modules/subscription/components/success/PaymentSuccess';
import { getStringQuery, parseQueries, queriesToCamelCase } from '@shared/utils/queries';
import { sanitizeReturnUrl } from '@modules/subscription/utils';

const PaymentSuccessPge: FC = () => {
  const location = useLocation();

  const returnUrl = useMemo(
    () => sanitizeReturnUrl(getStringQuery(queriesToCamelCase(parseQueries(location.search)), 'returnUrl')),
    [location.search],
  );

  return <PaymentSuccess returnUrl={returnUrl} />;
};

export default PaymentSuccessPge;
